import { useFormContext } from 'react-hook-form';
import { IExtrasFormData } from '../IExtrasFormData';

export function useExtrasFormContext() {
	return useFormContext<IExtrasFormData>();
}
